import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react'; // we'll install lucide-react
import { Button } from './Button';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  return (
    <Button variant="ghost" size="sm" onClick={toggleTheme} className="rounded-full p-2">
      {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
    </Button>
  );
};